import React from "react";
import _ from "lodash";
import moment from "moment";

import AddToCalendarModal from "../../../parts/modals/add-to-calendar";
import SuggestUpgradeModal from "../../../parts/modals/suggest-upgrade";
import SuggestUpgradePreviewModal from "../../../parts/modals/suggest-upgrade-preview";
import View from "./program-preview.view";

import { STRIPE } from "../../../constants";
import { isPushOrPerformClient } from "../../../utils/user-helpers";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const ProgramPreviewController = async ({ res, req, locals, load, api }) => {
  const { query, params } = req;
  const userToRequest = locals.activeUserToRequest;
  const hasOrganizationId = !!locals.activeUser.organizationId;

  _.defaults(query, {
    program: 1,
    week: 1,
    units: locals.units,
  });

  const modal = _.get(query, "modal", {});
  if (modal.type === "add-to-calendar") {
    let queryActiveExercises = {
      start: moment(-1),
      end: moment("December 30 2049"),
    };
    if (query.organizatinCoach) {
      queryActiveExercises = {
        ...queryActiveExercises,
        organizatinCoach: query.organizatinCoach,
      };
    }
    await load("activeExercises", queryActiveExercises);
  }

  const isSubscriber = isPushOrPerformClient(userToRequest);

  // `feCycles` is only sent for subscribers: a literal `false` used to end up in the cycle query of
  // organization sub-coaches and matched nothing, leaving `editCycle` undefined
  let queryEditCycle = {
    cycle: params.cycleId,
    feCycles: isSubscriber || undefined,
  };

  if (query.athlete) {
    await load("athlete", { user: query.athlete });
    if (hasOrganizationId) {
      queryEditCycle = {
        ...queryEditCycle,
        athleteFromOrganization: query.athlete,
      };
    }
  }

  const program =
    req.query.program && req.query.program > 0 ? req.query.program - 1 : 0;
  const programOrder = program + 1;

  locals.activeProgramIndex = program;
  locals.activeWeek = req.query.week || 1;

  const editExercisesOptions = locals.activeUser.organizationId
    ? {
        cycle: locals.params.cycleId,
        proxyAthlete: query.athlete,
        program: programOrder,
        forProgramEditor: true,
        organizationCoach: locals.activeUserToRequest._id,
      }
    : {
        cycle: locals.params.cycleId,
        proxyAthlete: query.athlete,
        program: programOrder,
        forProgramEditor: true,
      };

  await Promise.all([
    load("editCycle", queryEditCycle),
    load("cycleExercises", {
      cycle: locals.params.cycleId,
      program: programOrder,
      week: locals.activeWeek,
      allWeeks: true,
    }),
    //new load for program insights (without this we can't know the muscle group info)
    load("editExercises", editExercisesOptions),
    load("editSections", {
      cycle: params.cycleId,
      program: program + 1,
      proxyAthlete: query.athlete,
      ...(hasOrganizationId && {
        organizationCoach: locals.activeUserToRequest._id,
      }),
    }),
    load("complexes"),
    ...(query.athlete
      ? [load("clientConfiguration", { proxyAthlete: query.athlete })]
      : []),
  ]);

  locals.heading = ["Coaching", "Programs", locals.editCycle.name];

  locals.modal = {
    "add-to-calendar": <AddToCalendarModal cycle={locals.editCycle} />,
    "suggest-upgrade": <SuggestUpgradeModal api={api} />,
    "suggest-upgrade-preview": <SuggestUpgradePreviewModal api={api} />,
    "activity-feed": <ActivityDrawer />,
  }[_.get(locals.query, "modal.type")];

  const userPlan = _.get(locals.activeUserToRequest, "stripe.plan", "");

  const isPremium =
    userPlan === STRIPE.PLANS.V2.premiumMonthly ||
    userPlan === STRIPE.PLANS.V2.premiumAnnually;
  const isAdmin = locals.activeUser.permissions?.includes("admin");
  const isAmbassador = locals.activeUser.permissions?.includes("ambassador");

  if (
    locals.editCycle.type === "premium" &&
    !isPremium &&
    !isAdmin &&
    !isAmbassador &&
    locals.activeWeek > 1
  ) {
    return res.redirect(
      `/dashboard/program-library/program-preview/${locals.editCycle._id}?program=1&week=1#_`
    );
  }

  res.body = <View />;
};

export default ProgramPreviewController;
